import { combineReducers } from 'redux';
import { photoBookId, STATE_KEY as PHOTO_BOOK_ID_STATE_KEY } from './photoBookId';
import { context, STATE_KEY as CONTEXT_STATE_KEY } from './context';
import { bookSizes, STATE_KEY as BOOK_SIZES_STATE_KEY } from './bookSizes';
import { cover, STATE_KEY as COVER_STATE_KEY } from './cover';
import { dimensions, STATE_KEY as DIMENSIONS_STATE_KEY } from './dimensions';
import { folderId, STATE_KEY as FOLDER_STATE_KEY } from './folderId';
import { autofill, STATE_KEY as AUTOFILL_STATE_KEY } from './autofill';
import { maxSheets, STATE_KEY as MAX_STATE_KEY } from './maxSheets';
import { placeholderBorderSize, STATE_KEY as ADD_PLACEHOLDER_BORDER_SIZE } from './placeholderBorderSize';
import { isBabyBook, STATE_KEY as SET_IS_BABY_BOOK } from './isBabyBook';
import { isLoadable, STATE_KEY as IS_LOADABLE } from './isLoadable';


const bookProperties = combineReducers({
  [PHOTO_BOOK_ID_STATE_KEY]: photoBookId,
  [FOLDER_STATE_KEY]: folderId,
  [CONTEXT_STATE_KEY]: context,
  [BOOK_SIZES_STATE_KEY]: bookSizes,
  [COVER_STATE_KEY]: cover,
  [DIMENSIONS_STATE_KEY]: dimensions,
  [AUTOFILL_STATE_KEY]: autofill,
  [MAX_STATE_KEY]: maxSheets,
  [ADD_PLACEHOLDER_BORDER_SIZE]: placeholderBorderSize,
  [SET_IS_BABY_BOOK]: isBabyBook,
  [IS_LOADABLE]: isLoadable,
});

export default bookProperties;



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/index.js